<template>
    <div class="form-container">
        <template v-if="isAuth">
            <div v-if="message == ''" class="form">
                <h2>Forward Listing</h2>
                <p class="form-subheading">Driver broken down? Accountant needs vendor information? <br />Share this listing.</p>
                <div class="inputs-container">
                    <div class="methods-container">
                        <button :class="method == 'email' ? 'active' : ''" @click="selectEmail"><fa-icon :icon="['fas', 'envelope']" aria-hidden="true"></fa-icon>Send via Email</button>
                        <button :class="method == 'sms' ? 'active' : ''" @click="selectSms"><fa-icon :icon="['fas', 'message']" aria-hidden="true"></fa-icon>Send via Text Message</button>
                    </div>

                    <div class="form-fields">
                        <label>{{ label }}</label>
                        <div v-if="method == 'email'" :class="{ error: v$.emailAddress.$errors.length }">
                            <input type="email" :placeholder="'Enter ' + label.toLowerCase()" v-model="state.emailAddress" @blur="v$.emailAddress.$touch">
                            <div class="input-errors" v-for="error of v$.emailAddress.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div v-if="method == 'sms'" :class="{ error: v$.mobileNumber.$errors.length }">
                            <input type="tel" :placeholder="'Enter ' + label.toLowerCase()" v-model="state.mobileNumber" @blur="v$.mobileNumber.$touch">
                            <div class="input-errors" v-for="error of v$.mobileNumber.$errors" :key="error.$uid">
                                <span class="error-msg">{{ error.$message }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-buttons">
                    <button class="cancel-btn" @click="closeForm">Cancel</button>
                    <button class="forward-btn" @click="shareLocation">Forward</button>
                </div>
            </div>
            <div class="info-message" v-else>
                <div class="message">
                    <p>{{ message }}</p>
                </div>
                <div class="xmark">
                    <fa-icon :icon="['fas', 'xmark']" aria-hidden="true" @click="closeForm"></fa-icon>
                </div>
            </div>

        </template>
        <template v-else>
            <marketing-action class="py-0" :more-info-url="moreInfoUrl">
                <template #heading>
                    <h2>Forward Listing</h2>
                    <p>Driver broken down? <br />Accountant needs vendor information? <br /> Share this listing.</p>
                </template>
                <template #subheading>
                    <h3>This is a free feature available to logged-in accounts</h3>
                    <h4>Create a <strong>free account</strong> or <strong>login</strong> to quickly share with others!</h4>
                </template>
            </marketing-action>
        </template>
    </div>
</template>

<script>import script from './ListingForward';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingForward.less";
</style>
